// Timesheets (round 44): its own place in the sidebar.
//
// A field worker sees their own weeks. The office sees everybody's week as a
// board, and, when they fill in a timesheet themselves (an admin opts them in),
// their own this-week and last-week above it.
import { Link } from 'react-router-dom';
import { useSession } from '../session';
import { PageHeader } from '../components/ui/Page';
import { MyWeeks } from '../components/timesheets/MyWeeks';
import { TimesheetBoard } from '../components/timesheets/TimesheetBoard';

export function TimesheetsPage() {
  const { user } = useSession();
  if (!user) return null;

  if (user.role === 'field') {
    return (
      <>
        <PageHeader title="My timesheet" subtitle="Fill in your days, sign at the bottom, and submit each week." />
        <MyWeeks />
      </>
    );
  }

  return (
    <>
      <PageHeader
        title="Timesheets"
        subtitle="Hours as your people recorded them. Approve them, send them back, or correct them."
        actions={
          <Link to="/app/timesheets/export" className="btn-secondary">
            Export CSV
          </Link>
        }
      />
      {user.onTimesheets ? <MyWeeks compact /> : <OwnTimesheetHint isAdmin={user.role === 'admin'} />}
      <TimesheetBoard />
    </>
  );
}

/**
 * The office does not fill in a timesheet by default, so this page has no
 * "my week" for them. Without this line an admin who turns timesheets on
 * finds nowhere to enter their own hours, and nothing saying why (Nathan,
 * the day it went live). Only an admin can change who fills one in.
 */
function OwnTimesheetHint({ isAdmin }: { isAdmin: boolean }) {
  return (
    <p className="hint mb-4">
      Fill in your own timesheet?{' '}
      {isAdmin ? (
        <>
          Turn it on for yourself under <Link to="/app/settings/timesheets">Settings, Timesheets</Link>, then Who
          fills in a timesheet.
        </>
      ) : (
        'Ask an admin to turn it on for you under Settings, Timesheets.'
      )}
    </p>
  );
}
